var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkl-description-pencil-input" },
    [
      _vm.canEdit
        ? _c(
            "PencilEdit",
            {
              ref: "modal",
              attrs: {
                canEdit: true,
                displayValue: _vm.value || _vm.defaultHint,
              },
              on: {
                dblclick: function () {
                  return _vm.open()
                },
                open: _vm.onOpen,
                close: _vm.onClose,
              },
            },
            [
              _c("HKLInput", {
                directives: [{ name: "focus", rawName: "v-focus" }],
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.close.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.inputData,
                  callback: function ($$v) {
                    _vm.inputData = $$v
                  },
                  expression: "inputData",
                },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "field__display" }, [
            _vm._v("\n    " + _vm._s(_vm.value || _vm.defaultValue) + "\n  "),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }